<div class="container-fluid">
  <h1>Authentication Middleware</h1>
  <div>
    <p>Token: {{ token | async }}</p>
  </div>
</div>
